export default __webpack_public_path__ + "04203da47f262924ef79c3e33358b3f6.jpg";